import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import type { PageMetaLoaderData } from '@/lib/analytics/page-meta';
import { learningTracksKeys } from '@/lib/queries/learning-tracks';
import { loadForRoute } from '@/lib/queries/load-for-route';
import { editorialTitleSubject } from '@/lib/seo-text';
import { requirePlatformRole } from '@/lib/route-guards';
import {
  LearningTrackAdminSkeleton,
  LearningTrackAdminView,
} from '@/components/learning-tracks/LearningTrackAdminView';

export const Route = createFileRoute(
  '/_authed/admin/resources/learning-tracks/$trackId/',
)({
  beforeLoad: ({ params, context }) => {
    if (!isUuid(params.trackId)) throw notFound();
    requirePlatformRole(context, {
      role: 'admin',
      bounceTo: () =>
        redirect({
          to: '/resources/learning-tracks/$trackId',
          params: { trackId: params.trackId },
        }),
    });
  },
  loader: async ({ params, context: { queryClient } }): Promise<PageMetaLoaderData> => {
    const track = await loadForRoute(queryClient, {
      ...learningTracksKeys.detail(params.trackId),
      retry: false,
    });
    return track === undefined ? {} : { pageTitle: editorialTitleSubject(track) };
  },
  pendingComponent: LearningTrackAdminSkeleton,
  component: LearningTrackAdminPage,
});

function LearningTrackAdminPage() {
  const { trackId } = Route.useParams();
  return <LearningTrackAdminView trackId={trackId} />;
}
